__turbopack_context__.v({
  "className": "s-C7SG_className",
});
